import { arrayOf, oneOf, shape, string } from 'prop-types'

export const htmlLinkType = {
  text: string.isRequired,
  href: string.isRequired,
  target: oneOf(['_self', '_blank']),
}

export const linksType = arrayOf(shape(htmlLinkType))
